import React from "react";
import PropTypes from "prop-types";

import Body from "./components/Body";
import CustomContent from "./components/CustomContent";
import Footer from "./components/Footer";
import SuccessIcon from "./components/SuccessIcon";
import Text from "./components/Text";
import Title from "./components/Title";
import * as S from "./styled";

export const ModalContext = React.createContext({ layout: "default" });

function SuccessMessageModal(props) {
  return (
    <ModalContext.Provider value={{ layout: props.layout }}>
      <S.SuccessMessageModal
        {...props}
        data-qa="message-success-modal"
        isOpen={props.isOpen}
        onRequestClose={props.onClose}
        theme="lightBox"
      >
        <S.ModalContent {...props} layout={props.layout} />
      </S.SuccessMessageModal>
    </ModalContext.Provider>
  );
}

SuccessMessageModal.Body = Body;
SuccessMessageModal.CustomContent = CustomContent;
SuccessMessageModal.Footer = Footer;
SuccessMessageModal.SuccessIcon = SuccessIcon;
SuccessMessageModal.Text = Text;
SuccessMessageModal.Title = Title;

SuccessMessageModal.Body.displayName = "SuccessMessageModal.Body";
SuccessMessageModal.CustomContent.displayName =
  "SuccessMessageModal.CustomContent";
SuccessMessageModal.Footer.displayName = "SuccessMessageModal.Footer";
SuccessMessageModal.SuccessIcon.displayName = "SuccessMessageModal.SuccessIcon";
SuccessMessageModal.Text.displayName = "SuccessMessageModal.Text";
SuccessMessageModal.Title.displayName = "SuccessMessageModal.Title";

SuccessMessageModal.propTypes = {
  isOpen: PropTypes.bool,
  layout: PropTypes.oneOf(["default", "custom"]),
  onClose: PropTypes.func
};

SuccessMessageModal.defaultProps = {
  isOpen: false,
  layout: "default",
  onClose: () => {}
};

export default SuccessMessageModal;
